import { getCurrentIntl } from '../i18n/intl/intl';

export const intlFormatRfiStatus = (label: string) => {
  const intl = getCurrentIntl();
  const intlLabels = [
    // Status Labels
    intl.formatMessage({ defaultMessage: 'Pending' }),
    intl.formatMessage({ defaultMessage: 'Responded' }),
    intl.formatMessage({ defaultMessage: 'Viewed' }),
    intl.formatMessage({ defaultMessage: 'Closed' }),
  ];
  
  const matchedLabel = intlLabels.find(intlLabel => intlLabel === label);
    
  return matchedLabel || label;
};